import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CallbackPage_content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "lds-heart" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "CallbackPage_maintenance"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "CallbackPage_loginPanel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Logging in takes too long?", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Try repeating the process with following steps:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "CallbackPage" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.isMaintenance)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
              _createTextVNode("Park.it is under maintenance"),
              _hoisted_4,
              _createTextVNode("we'll come back soon...")
            ]))
          : _createCommentVNode("", true),
        (_ctx.isLoginPanelVisible && !_ctx.isMaintenance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("p", null, [
                _createTextVNode("1. Logout from previous session: "),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSoftLogoutClick && _ctx.handleSoftLogoutClick(...args)))
                }, " Soft logout "),
                _createTextVNode(" or "),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleForceLogoutClick && _ctx.handleForceLogoutClick(...args)))
                }, " Force logout ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode("2. Login to a new session: "),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)))
                }, " Login "),
                _createTextVNode(" or back to "),
                _createElementVNode("span", {
                  class: "CallbackPage_link",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleHomeClick && _ctx.handleHomeClick(...args)))
                }, " Home Screen ")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}